<template>
    <div class="Applicants" ref="panecontainer">
        
        <b-row class="dashboard-row">
            <b-col>
                <b-row><b-col><h2>Applicant Snapshot Report: </h2></b-col></b-row>
                <b-row><b-col><h4>Download Snapshot (new) Report <a :href="PBIURL">HERE</a>.</h4></b-col></b-row>
            </b-col>
        </b-row>
        
        <b-row class="dashboard-row">
            <b-col>
                <b-row><b-col><h2>Contact Record Reports: </h2></b-col></b-row>
                <b-row><b-col><h4>Orange County Foster: <a :href="CR_Report_Orange">DOWNLOAD</a>.</h4></b-col></b-row>
                <b-row><b-col><h4>LA Foster: <a :href="CR_Report_LA">DOWNLOAD</a>.</h4></b-col></b-row>
                <b-row><b-col><h4>Inland Foster: <a :href="CR_Report_Inland">DOWNLOAD</a>.</h4></b-col></b-row>
                <b-row><b-col><h4>San Diego Foster: <a :href="CR_Report_SanDiego">DOWNLOAD</a>.</h4></b-col></b-row>
                <b-row><b-col><h4>Las Vegas Foster: <a :href="CR_Report_LasVegas">DOWNLOAD</a>.</h4></b-col></b-row>
                <b-row><b-col><h4>North Sound Foster: <a :href="CR_Report_NorthSound">DOWNLOAD</a>.</h4></b-col></b-row>
                <b-row><b-col><h4>South Sound Foster: <a :href="CR_Report_SouthSound">DOWNLOAD</a>.</h4></b-col></b-row>
                <b-row><b-col><h4>West Sound Foster: <a :href="CR_Report_WestSound">DOWNLOAD</a>.</h4></b-col></b-row>
            </b-col>
            
        </b-row>
    </div>
</template>

<script>

    //import components


    export default {
        created() {
        },
        props: [],
        data: function () {
            return {
                PBIURL: "https://portal.olivecrest.org/API/Core/Files/GetFileContent/ApplicantReport.pbix?FileID=283514e6-fd56-4fee-a039-874496734829",
                CR_Report_Orange: "https://portal.olivecrest.org/API/Core/Files/GetFileContent/FosterContactRecords_OrangeCounty.pbix?FileID=324aafde-5cb9-4efe-8fad-cae0e4fdfbf7",
                CR_Report_LA: "https://portal.olivecrest.org/API/Core/Files/GetFileContent/FosterContactRecords_LosAngeles.pbix?FileID=ac2d8109-e54b-446a-93a3-1d99ed3b9d58",
                CR_Report_Inland: "https://portal.olivecrest.org/API/Core/Files/GetFileContent/FosterContactRecords_Inland.pbix?FileID=5382ec38-baff-4b95-975b-754beaaff647",
                CR_Report_SanDiego: "https://portal.olivecrest.org/API/Core/Files/GetFileContent/FosterContactRecords_SanDiego.pbix?FileID=b308377d-6e46-4e4c-b8fe-ec3878917d4b",
                CR_Report_LasVegas: "https://portal.olivecrest.org/API/Core/Files/GetFileContent/FosterContactRecords_LasVegas.pbix?FileID=fa7c3fa7-93e7-4b7c-bc80-3744d2a52767",
                CR_Report_NorthSound: "https://portal.olivecrest.org/API/Core/Files/GetFileContent/FosterContactRecords_NorthSound.pbix?FileID=d7d170f4-d0fe-410b-a317-f8057f559a00",
                CR_Report_SouthSound: "https://portal.olivecrest.org/API/Core/Files/GetFileContent/FosterContactRecords_SouthSound.pbix?FileID=f52837cd-e67c-479d-ba17-092f8102e94f",
                CR_Report_WestSound: "https://portal.olivecrest.org/API/Core/Files/GetFileContent/FosterContactRecords_WestSound.pbix?FileID=2b7398f1-3e11-4e27-be77-3c6e2576c90f"
            };
        },
        methods: {
            
        },
        components: {

        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptionsFiltered"]("Foster");
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
</style>